import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ControlVehiculosService } from 'src/app/services/admin/control-vehiculos-service/control-vehiculos.service';
import { ConfirmDialog } from 'src/app/shared/confirmdialog/confirmdialog.component';
import { Gtp } from 'src/app/shared/gtp';
import { ControlDestinatarios } from './control-destinatarios';
import { ControlPerfil } from './control-perfil';

// import { Gtp } from 'src/app/shared/gtp';
import { ListaMovilesService } from 'src/app/shared/services/lista-moviles.service';
import { MovilSidebar } from 'src/app/models/movil-sidebar.model';
//import { ControlGeocercaService } from 'src/app/services/flota/control-geocerca-service/control-geocerca.service';
import { ControlVehiculosGeocerca } from '../control-vehiculos-geocerca/control-vehiculos-geocerca.component';
import { ControlVehiculosEventos } from '../control-vehiculos-eventos/control-vehiculos-eventos.component';
import { ControlVehiculosMovimiento } from '../control-vehiculos-movimiento/control-vehiculos-movimiento.component';
import { ControlVehiculosMantenimiento } from '../control-vehiculos-mantenimiento/control-vehiculos-mantenimiento.component';
import { Validators } from '@angular/forms';
import { ControlVehiculosLista } from '../control-vehiculos-listavehiculos/control-vehiculos-listavehiculos.component';
import { ControlVehiculosSinTransmitir } from '../control-vehiculos-sintransmitir/control-vehiculos-sintransmitir.component';
import { ControlVehiculosRutas } from '../control-vehiculos-rutas/control-vehiculos-rutas.component';
import { ControlVehiculosDestinatarios } from '../control-vehiculos-destinatarios/control-vehiculos-destinatarios.component';

interface Correo {
  id: number;
  correo: string;
}

@Component({
  selector: 'app-control-vehiculos',
  templateUrl: './control-vehiculos.component.html',
  styleUrls: ['./control-vehiculos.component.scss']
})

export class AdminControlVehiculos implements OnInit {

  codVehiculo: any;
  fecha_hora: any;
  inputAddDestinatario: boolean = false;

  //ABM Perfil
  showCreatePerfil: boolean = false;
  loadingCreatePerfil: boolean = false;
  savedCreatePerfil: boolean = false;
  msgPerfil = { state: false, class: '', txt: '' };

  //ABM DESTINATARIOS
  public agregar_correo_destinatario;
  public destinatariosSugeridos: any[] = [];
  public loadingDestinatarios: boolean = false;

  //CONFIG VEHICULO
  configPerfil = {
    perfil: null,
    destinatarios: [],
    vehiculos: [],
    geocercas: [],
    eventos: [],
    mantenimiento: [],
    sintransmitir: [],
    movimiento: [],
    rutas: [],
  }
  showAddVehiculo:boolean = false;

  public itemTipoControl = [
    {
      nombre: 'Control de Eventos',
      ruta: 'control-eventos',
    },
    {
      nombre: 'Control de Geocerca',
      ruta: 'control-geocerca',
    },
    {
      nombre: 'Control de Mantenimiento',
      ruta: 'control-mantenimiento',
    },
    {
      nombre: 'Control de Movimiento',
      ruta: 'control-movimiento',
    },
    {
      nombre: 'Informes',
      ruta: 'control-informes',
    },
    {
      nombre: 'Control de Rutas',
      ruta: 'control-rutas',
    },
    {
      nombre: 'Control Sin Transmitir',
      ruta: 'control-sintransmitir',
    },
  ];
  public itemTipoControlFiltered = []

  public secActiva:any = null;

  public perfiles:any = [];
  public perfilesFiltered:any = [];
  public perfil = null;


  public showElegirPerfil:boolean = true; //nuevo
  public showNuevoPerfil:boolean = true; //nuevo
  public showTipoControl:boolean = false; //nuevo

  public loadingDelPerfil:boolean = false;
  public agregarPerfilNombre = null;

  public vehiculos:any = [];
  public vehiculosFilter:any = [];
  public vehiculoElegido:any = [];

  public rutas = [];
  public geocerca = [];
  public movimiento = [];
  public eventos = [];
  public mantenimiento = [];
  public sintransmitir = [];
  public imgvehiculo = [];
  public autorizada = [];

  public totalVehiculos:any = [];
  public totalVehiculosFilter:any = [];

  //SUSCRIBERS PARA INTERNAS
  configGeocercaSuscr; //configGeocerca
  configEventosSuscr; //configEventos
  configMantenimientoSuscr; //configEventos
  configVehiculosSuscr; //configEventos
  configSinTransmitirSuscr; //configEventos
  configRutasSuscr; //configEventos

  constructor(
    public gtp: Gtp,
    private router: Router,
    private dialog: MatDialog,
    public listamovilesservice: ListaMovilesService,
    private ctrlPerfil: ControlPerfil,
    private ctrlVehiculo: ControlVehiculosService,
  ) {
    this.getListaPerfiles();
    this.itemTipoControlFiltered = this.itemTipoControl;
  }

  ngOnInit(){

    //this.loadMoviles();
    //this.loadConfiganel('control-rutas');
  }

  closeMovil(){
    this.gtp.setAdminSidebar(true);
  }

  //Limpia los suscribers
  clearSuscribe(){
    //Limpia los escuchas de config de geocerca
    if (this.configGeocercaSuscr) { this.configGeocercaSuscr.complete(); }
  }

  loadConfiganel(config){
    this.clearSuscribe();
    this.gtp.cerrarVentanas(true);
    let clear = true;
    if (config == 'control-geocerca'){
      this.configGeocerca();
      this.gtp.setMainOutlet(ControlVehiculosGeocerca);
      clear = false;
    }
    if (config == 'control-eventos'){
      this.configEventos();
      this.gtp.setMainOutlet(ControlVehiculosEventos);
      clear = false;
    }
    if (config == 'control-movimiento'){
      this.configMovimiento();
      this.gtp.setMainOutlet(ControlVehiculosMovimiento);
      clear = false;
    }
    if (config == 'control-mantenimiento'){
      this.configMantenimiento();
      this.gtp.setMainOutlet(ControlVehiculosMantenimiento);
      clear = false;
    }
    if (config == 'lista-vehiculos'){
      this.configVehiculos();
      this.gtp.setMainOutlet(ControlVehiculosLista);
      this.secActiva = null;
      clear = false;
    }
    if (config == 'control-sintransmitir'){
      this.configSinTransmitir();
      this.gtp.setMainOutlet(ControlVehiculosSinTransmitir);
      clear = false;
    }
    if (config == 'control-rutas'){
      this.configRutas();
      this.gtp.setMainOutlet(ControlVehiculosRutas);
      clear = false;
    }
    if (config == 'gestionar-destinatarios'){
      this.gtp.setMainOutlet(ControlVehiculosDestinatarios);
      clear = false;
    }
    if (config == 'control-informes'){
      this.configInformes();
      this.gtp.setMainOutlet(ControlVehiculosEventos);
      clear = false;
    }
    if (clear){
      this.secActiva = null;
    }
  }

  configGeocerca() {
    this.ctrlVehiculo.geocercaConfig = this.configPerfil.geocercas;
    this.configGeocercaSuscr = this.ctrlVehiculo.getGeocercaConfigObs().subscribe(res => {
      this.configPerfil.geocercas = res;
      this.updatePerfil();
    });
    if (this.configPerfil.geocercas) {
      //this.ctrlVehiculo.setGeocercaConfig(this.configPerfil.geocercas);
    }
  }

  configEventos() {
    this.ctrlVehiculo.eventosConfig = this.configPerfil.eventos;
    this.configEventosSuscr = this.ctrlVehiculo.getListaEventosConfigObs().subscribe(res => {
      this.configPerfil.eventos = res;
      this.updatePerfil();
    });
    if (this.configPerfil.eventos) {
      this.ctrlVehiculo.eventosConfig = this.configPerfil.eventos;
    }

    // Establecer tipo de configuración
    this.ctrlVehiculo.tipoConfiguracion = 'eventos';

    // NUEVO: Notificar al componente de eventos que debe recargar configuración
    console.log('🚀 Componente padre: Solicitando recarga de eventos');
    setTimeout(() => {
      this.ctrlVehiculo.notificarRecargaEventos();
    }, 100);
  }

  configMovimiento() {
    this.ctrlVehiculo.MovimientoConfig = this.configPerfil.movimiento;
    this.configMantenimientoSuscr = this.ctrlVehiculo.getMovimientoConfigObs().subscribe(res => {
      this.configPerfil.movimiento = res;
      this.updatePerfil();
    });
    if (this.configPerfil.movimiento) {
      this.ctrlVehiculo.MovimientoConfig = this.configPerfil.movimiento;
    }
  }

  configMantenimiento() {
    this.ctrlVehiculo.mantenimientoConfig = this.configPerfil.mantenimiento;
    this.configMantenimientoSuscr = this.ctrlVehiculo.getMantenimientoConfigObs().subscribe(res => {
      this.configPerfil.mantenimiento = res;
      this.updatePerfil();
    });
    if (this.configPerfil.mantenimiento) {
      this.ctrlVehiculo.mantenimientoConfig = this.configPerfil.mantenimiento;
    }
  }

  configVehiculos() {
    this.ctrlVehiculo.VehiculosConfig = this.configPerfil.vehiculos;
    this.configVehiculosSuscr = this.ctrlVehiculo.getVehiculosConfigObs().subscribe(res => {
      this.configPerfil.vehiculos = res;
      this.updatePerfil();
    });
    if (this.configPerfil.vehiculos) {
      this.vehiculosFilter = this.ctrlVehiculo.VehiculosConfig = this.configPerfil.vehiculos;
    }
  }

  configSinTransmitir() {
    this.ctrlVehiculo.SinTransmitirConfig = this.configPerfil.sintransmitir;
    this.configSinTransmitirSuscr = this.ctrlVehiculo.getSinTransmitirConfigObs().subscribe(res => {
      this.configPerfil.sintransmitir = res;
      this.updatePerfil();
    });
    if (this.configPerfil.sintransmitir) {
      this.ctrlVehiculo.SinTransmitirConfig = this.configPerfil.sintransmitir;
    }
  }

  configRutas() {
    this.ctrlVehiculo.RutasConfig = this.configPerfil.rutas;
    this.configRutasSuscr = this.ctrlVehiculo.getRutasConfigObs().subscribe(res => {
      this.configPerfil.rutas = res;
      this.updatePerfil();
    });
    if (this.configPerfil.rutas) {
      this.ctrlVehiculo.RutasConfig = this.configPerfil.rutas;
    }
  }

  configInformes() {
    // Configuración específica para informes (incluye paradas, informe completo y otros informes globales)
    this.ctrlVehiculo.eventosConfig = this.configPerfil.eventos;
    this.configEventosSuscr = this.ctrlVehiculo.getListaEventosConfigObs().subscribe(res => {
      this.configPerfil.eventos = res;
      this.updatePerfil();
    });
    if (this.configPerfil.eventos) {
      this.ctrlVehiculo.eventosConfig = this.configPerfil.eventos;
    }

    // Notificar que se está configurando informes específicamente
    this.ctrlVehiculo.tipoConfiguracion = 'informes';
    setTimeout(() => {
      this.ctrlVehiculo.notificarRecargaEventos();
    }, 100);
  }

  filterTipoControl(query) {
    let res = this.itemTipoControl.filter(s => (s.nombre.toLocaleLowerCase().includes(query.toLocaleLowerCase())));
    this.itemTipoControlFiltered = (query == '') ? this.itemTipoControl : res;
  }

  toggleAgregarDestinatario(){
    this.inputAddDestinatario = !this.inputAddDestinatario;
  }

  deleteDestinatario(id, pos){
    const dialogRef = this.dialog.open(ConfirmDialog, {
      width: this.gtp.confirmMinWidh,
      data: {
        value: id,
        titulo: 'BORRAR DESTINATARIO',
        descr: '¿Está seguro que querer eliminar el registro?',
        success_class: 'danger',
        success_text: 'Eliminar'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result){
          this.configPerfil.destinatarios.splice(pos, 1);
          this.gtp.successNotif('Destinatario eliminado');
      }
    });
  }

  updatePerfil(){
    //let save = true;
    // if ( this.configPerfil.destinatarios.length==0 ) {
    //   this.gtp.errorNotif('Favor agregar destinatarios');
    //   save = false;
    // }
    // if ( this.configPerfil.vehiculos.length==0 ) {
    //   this.gtp.errorNotif('Favor agregar vehiculos');
    //   save = false;
    // }
    //if (save){
      this.ctrlPerfil.updatePerfil(this.configPerfil).subscribe(
        result => { this.gtp.successNotif('Perfil Actualizado'); },
        error => { this.gtp.errorNotif('No se pudo actualizar el perfil'); },
        () => {}
      );
    //}
  }

  //ABM PERFILES
  mostrarCrearNuevoPerfil(a){
    //console.log(a)
    if (a) {
      this.showCreatePerfil = true
      this.showNuevoPerfil = false
      this.showElegirPerfil = false
    } else {
      this.showCreatePerfil = false
       this.showNuevoPerfil = true
      this.showElegirPerfil = true
    }
  }
  getListaPerfiles() {
    this.ctrlPerfil.getListaPerfiles().subscribe(res => {
      this.perfiles = res;
      this.perfilesFiltered = res;
    });
    this.ctrlPerfil.listaPerfiles();
  }

  getPerfil(perfil) {
    if (perfil == '') {
      console.log(perfil)
      this.showTipoControl = false
      this.showNuevoPerfil = true //para agregar nuevo perfil
      this.showElegirPerfil = true
      this.configPerfil.perfil = false
      this.perfil = null; // Resetear perfil seleccionado
    }else{
      this.showTipoControl = true
      this.showNuevoPerfil = false
      this.showElegirPerfil = true // Mantener selector visible
      this.showCreatePerfil = false;
      this.perfil = perfil; // Guardar perfil seleccionado para poder eliminarlo

      this.gtp.cerrarVentanas(true);
      this.secActiva = null;

      if (perfil) {
        //console.log(perfil)
        this.ctrlPerfil.getPerfil(perfil.id_perfil).subscribe(res => {
            let perfilData = res['rows'];
            console.log('🔍 Datos del perfil desde API:', perfilData);

            this.configPerfil.perfil = res['rows'];
            this.configPerfil.vehiculos = this.vehiculosFilter = perfilData.vehiculos;
            this.configPerfil.destinatarios = perfilData.destinatarios;
            this.configPerfil.geocercas = perfilData.geocercas;
            this.configPerfil.eventos = perfilData.eventos;
            this.configPerfil.mantenimiento = perfilData.mantenimiento;
            this.configPerfil.sintransmitir = perfilData.sintransmitir;
            this.configPerfil.rutas = perfilData.rutas;

            console.log('✅ configPerfil construido:', {
              perfil: this.configPerfil.perfil,
              destinatarios: this.configPerfil.destinatarios,
              destinatariosCount: this.configPerfil.destinatarios?.length || 0,
              vehiculos: this.configPerfil.vehiculos?.length || 0
            });

            // Establecer el perfil actual en el servicio para compartir con otros componentes
            this.ctrlVehiculo.setPerfilActual(this.configPerfil);

            console.log('📡 Perfil establecido en servicio:', this.configPerfil);
        });
      } else {
        this.configPerfil.perfil = null;
        this.configPerfil.vehiculos = [];
        this.configPerfil.destinatarios = [];
        this.configPerfil.geocercas = [];
        this.configPerfil.eventos = [];
        this.configPerfil.mantenimiento = [];
        this.configPerfil.sintransmitir = [];
        this.configPerfil.rutas = [];
      }
    }
  }

  createPerfil() {
    let perfil = {
      nombre: this.agregarPerfilNombre,
      //vehiculos: this.configPerfil.vehiculos
    }
    if (Validators.pattern('^(?:\d{10}|\w+@\w+\.\w{2,3})$')){
      this.loadingCreatePerfil = true;
      this.ctrlPerfil.createPerfil(perfil).subscribe(res => {
        // Resetear estado de creación
        this.showCreatePerfil = false;
        this.showNuevoPerfil = true;
        this.showElegirPerfil = true;

        // Mensaje de éxito
        this.msgPerfil = { state: true, txt: 'Perfil Creado Exitosamente', class: 'success' };

        // Limpiar mensaje después de 3 segundos
        setTimeout(() => {
          this.clearMsgPerfil();
        }, 3000);

        // Recargar lista de perfiles para que aparezca el nuevo
        this.getListaPerfiles();

      }, error => {
        this.msgPerfil = { state: true, txt: 'Error al crear el perfil', class: 'danger' };
        setTimeout(() => { this.clearMsgPerfil(); }, 3000);
      }, () => {
        this.agregarPerfilNombre = null;
        this.loadingCreatePerfil = false;
      });
    } else {
      this.msgPerfil = { state: true, txt: 'Por favor ingrese un nombre válido', class: 'warning' };
      setTimeout(() => { this.clearMsgPerfil(); }, 3000);
    }
  }

  deletePerfil(deletePerfil) {
    if (!this.perfil || !this.perfil.id_perfil) {
      this.gtp.errorNotif('No hay perfil seleccionado para eliminar');
      return;
    }

    const dialogRef = this.dialog.open(ConfirmDialog, {
      width: this.gtp.confirmMinWidh,
      data: {
        value: this.perfil.id_perfil,
        titulo: 'BORRAR PERFIL',
        descr: `¿Está seguro que quiere eliminar el perfil "${this.perfil.nombre}"?`,
        success_class: 'danger',
        success_text: 'Eliminar'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadingDelPerfil = true;
        this.ctrlPerfil.delPerfil(this.perfil.id_perfil).subscribe(res => {
          // Resetear estado completo
          this.configPerfil.perfil = null;
          this.perfil = null;
          this.showTipoControl = false;
          this.showNuevoPerfil = true;
          this.showElegirPerfil = true;

          // Mensaje de éxito
          this.msgPerfil = { state: true, txt: 'Perfil Eliminado Exitosamente', class: 'success' };
          setTimeout(() => { this.clearMsgPerfil(); }, 3000);

          // Recargar lista de perfiles
          this.getListaPerfiles();
        }, error => {
          this.msgPerfil = { state: true, txt: 'Error al eliminar el perfil', class: 'danger' };
          setTimeout(() => { this.clearMsgPerfil(); }, 3000);
        }, () => {
          this.loadingDelPerfil = false;
        });
      } else {
        this.loadingDelPerfil = false;
      }
    });
  }

  filterPerfiles(query) {
    console.log(query)

    if (this.msgPerfil.state) {
      this.clearMsgPerfil();
    }
    let res = this.perfiles.filter(s => (s.nombre.toLocaleLowerCase().includes(query.toLocaleLowerCase())));
    this.perfilesFiltered = (query == '') ? this.perfiles : res;
  }

  clearMsgPerfil(){
    this.msgPerfil = { state: false, class: '', txt: '' };
  }

  //ABM DESTINTARIOS
  addDestinatario(){
    let res = this.configPerfil.destinatarios.filter(s => (s.toLocaleLowerCase().includes(this.agregar_correo_destinatario.toLocaleLowerCase())));
    if(res.length==0){
      if (this.gtp.validateEmail(this.agregar_correo_destinatario) || this.gtp.validatePhone(this.agregar_correo_destinatario)){
        this.configPerfil.destinatarios.push(this.agregar_correo_destinatario);
        this.agregar_correo_destinatario = null;
        this.inputAddDestinatario = false;
        this.gtp.successNotif('Destinatario Agregado');
      } else {
        this.gtp.errorNotif('Favor Verifique el destinatario');
      }
    }
  }

}
